// @ts-check

$(() => {
  const $cookieConsent = $('.cc-window');

  if ($cookieConsent.length === 0) {
    return;
  }

  $cookieConsent.on('click', 'button', (e) => {
    setCookie(e.target.value);
    $cookieConsent.css({ opacity: 0 });
  });
});

/**
 * @param {string} value
 */
function setCookie(value) {
  /** @type {Date} */
  const date = new Date();

  date.setHours(date.getHours() + (365 * 24));

  const cookie = [
    'cookieconsent_status=' + (value === 'allow' ? 'allow' : 'deny'),
    'expires=' + date.toUTCString(),
    'path=/',
    'secure',
    'samesite=none',
  ];

  document.cookie = cookie.join(';');
}
